import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Carousel } from './carousel.model';

const axios = useAxios();

export interface CabinetService {
  Fetch: () => Promise<AxiosResponse<Carousel[]>>;
}

const Fetch = (): Promise<AxiosResponse<Carousel[]>> =>
  axios.Get<Carousel[]>('/api/carousels');

export default { Fetch } as CabinetService;
